export class LoginExceptionModel {
    IsLock?: boolean;
    LockOn?: Date;
    LockDuration?: number;
    FailedAttempCount?: number;
    RemainingSecond?: number;
}
